// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".analysis-group-list {\n  margin: 0;\n  padding: 0;\n}\n\n.analysis-group-list li {\n  margin: 10px 0;\n  padding: 0 10px;\n  list-style: none;\n  border-bottom: 1px solid #DDDDDD;\n}\n", ""]);
// Exports
module.exports = exports;
